import { usePageDataset } from '../../../templates/PageDatasetsContext';

export interface Icon {
    color: {
        value: {
            codename: string;
        }[];
    };
    icon_svg_file: {
        value: {
            url: string;
            description: string;
        }[];
    };
    wellness_type: {
        value: {
            name: string;
            codename: string;
        }[];
    };
    blog_topic: {
        value: {
            name: string;
            codename: string;
        }[];
    };
}

export interface IconNode {
    node: {
        elements: Icon;
    };
}

interface IconQuery {
    allKontentItemMediaIcon: {
        edges: IconNode[];
    };
}

export const useIcons = (): IconNode[] => {
    const icons: IconQuery['allKontentItemMediaIcon'] =
        usePageDataset('pageIcons');

    return icons?.edges ?? [];
};
